import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';

import styles from './negative-filter.module.css';

type Props = {
    name: string;
    isNot: boolean;
    onChange: (value: boolean) => any;
};

export class NegativeFilter extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles.container}>
                <RadioGroup
                    selectedValue={this.props.isNot ? 'false' : 'true'}
                    name={this.props.name}
                    onChange={this.handleChange}
                >
                    <Radio value='true'>Is</Radio>
                    <Radio value='false'>Is not</Radio>
                </RadioGroup>
            </div>
        );
    }

    handleChange = (value: string) => {
        this.props.onChange(value === 'true');
    };
}
